var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon club-logo",
    "aria-hidden": "true",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 80 80",
    id: "icn-aflc-carl",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#031E2F",
    d: "M40.056 60.113c9.712.282 21.021-3.906 25.069-7.735l-3.148-5.78s-8.644 7.227-21.921 6.7v-2.74c3.04.032 9.207-.114 14.118-1.576v-4.77s-7.791 1.832-14.118 1.244v-1.148h3.778V38.47h-3.778v-1.637c2.572-.268 6.567-.102 12.669 1.313l.038-4.847s-7.5-1.558-12.707-1.224v-2.672a64.801 64.801 0 018.986.14v2.116h4.822l-.002-1.486c1.852.33 3.74.776 5.597 1.372l1.717-8.128s-2.916-.761-7.323-1.244l-.003-2.648V13h-5.781v2.118h-8.986V13h-3.907l.015 2.118v8.004C26.659 25.248 18.372 30.36 14.5 41.503c0 0 4.62 14.698 20.69 18.04v2.221h-4.292v4.98h14.48v-4.98h-5.322v-1.65zM35.19 44.251c-1.23-.605-2.182-1.458-2.69-2.633 0 0 .681-1.71 2.69-2.993v5.626zm4.865-24.783h8.986v2.356c-2.779-.098-5.844-.02-8.986.388v-2.744zm-16.37 22.093s.364-7.031 11.505-11.266v2.783c-2.435.893-6.296 3.102-8.385 8.425 0 0 1.711 5.634 8.385 8.167v2.84c-3.582-1.1-9.328-3.921-11.504-10.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#icn-aflc-carl"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarl);
export default __webpack_public_path__ + "static/media/CARL.7202ef3f92df22d04d6bd5aec693f23c.svg";
export { ForwardRef as ReactComponent };